import { useQuery, gql, useApolloClient } from '@apollo/client';

export const TASK_ASSIGNMENT_COUNTS_QUERY = gql`
  query taskAssignmentCounts(
    $projectId: String!
    $page: Int
    $pagesize: Int
    $filter: GetResourceUsersFilter
    $textSearch: String
  ) {
    project(projectId: $projectId) {
      id
      tasksCount(isOpen: true, textSearch: $textSearch)
    }
    resourceUsers2(page: $page, pagesize: $pagesize, filter: $filter) {
      id
      assignedTasksCount(
        assignedTasksCountInput: {
          projectId: $projectId
          textSearch: $textSearch
        }
      )
    }
  }
`;

const updateTaskAssignmentCountsCache = ({
  proxy,
  variables
}) => isAssignedTask => {
  const data = proxy.readQuery({
    query: TASK_ASSIGNMENT_COUNTS_QUERY,
    variables
  });

  const previousAssignedTasksCount = data.resourceUsers2[0].assignedTasksCount;
  const updatedData = {
    ...data,
    resourceUsers2: [
      {
        ...data.resourceUsers2[0],
        assignedTasksCount: isAssignedTask
          ? previousAssignedTasksCount - 1
          : previousAssignedTasksCount + 1
      }
    ]
  };

  proxy.writeQuery({
    query: TASK_ASSIGNMENT_COUNTS_QUERY,
    data: updatedData,
    variables
  });
};

export default function useTaskAssignmentCounts({
  projectId,
  userId,
  textSearch
}) {
  const apolloClient = useApolloClient();
  const variables = {
    projectId,
    page: 1,
    pagesize: 1,
    filter: {
      userIds: [userId]
    },
    textSearch
  };

  const { loading, data } = useQuery(TASK_ASSIGNMENT_COUNTS_QUERY, {
    variables,
    skip: !projectId || !userId,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  });

  return {
    loading,
    totalTasksCount: data?.project?.tasksCount,
    assignedTasksCount: data?.resourceUsers2?.[0]?.assignedTasksCount,
    updateTaskAssignmentCountsCache: updateTaskAssignmentCountsCache({
      proxy: apolloClient.cache,
      variables
    })
  };
}
